<template>
    <div>
        <div class="page-title">
            <span>衣橱批量上传</span>
            <div class="extra">
                <div class="btn mr-2" @click="showUploader = true">上传照片</div>
                <div class="btn mr-2" @click="handleGenerateAll">全部生成白底图</div>
                <div class="btn" @click="joinWardrobeAll">全部导入衣橱</div>
            </div>
        </div>
        
        <div class="page-content" v-if="isShow">
            <w-t-member :member="jobDetail.member"></w-t-member>
            <div class="job-list" v-if="showUploader">
                <div class="close-btn" @click="showUploader = false">×</div>
                <w-uploader :jobId="jobDetail.id" @upload="getJobDetail(true)"></w-uploader>
            </div>
            <div class="job-list" v-if="hasJob">
                <template v-for="(item,key) in jobDetail.jobs">
                    <w-task-item :item="item" :key="key" @deleted="handleDelete" @itemUpdate="handleUpdate"
                                 @joinWardrobe="joinWardrobe"></w-task-item>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import api from "@/repo/api";
import WTMember from "@/views/AST/WardrobeTask/Com/WTMember.vue";
import WTaskItem from "@/views/AST/WardrobeTask/Com/WTaskItem.vue";
import WUploader from "@/views/AST/WardrobeTask/Com/WUploader.vue";

export default {
    name: 'WardrobeTaskDetail',
    components: {WUploader, WTaskItem, WTMember},
    data() {
        return {
            id: "",
            showAuth: false,
            jobDetail: {
                member: {},
                jobs: [],
                wardrobe_id: 0,
                am_id: 0,
                wardrobe_authed: false
            },
            isPageDestroyed: false,
            showUploader: false,
            showPop: false,
            scrollTop: 0,
            oldScrollTop: 0
        }
    },
    computed: {
        isShow() {
            return this.jobDetail && this.jobDetail.member && this.jobDetail.member.id;
        },
        hasJob() {
            return this.jobDetail && this.jobDetail.jobs && this.jobDetail.jobs.length;
        }
    },
    beforeDestroy() {
        this.isPageDestroyed = true;
    },
    mounted() {
        this.id = this.$route.params.id;
        this.getJobDetail()
    },
    methods: {
        auth() {
            this.showAuth = true;
        },
        closeAuth() {
            this.showAuth = false;
        },
        handleDelete(item) {
            this.jobDetail.jobs = this.jobDetail.jobs.filter(job => job.id !== item.id);
        },
        async joinWardrobe(item) {
            await this.doJoinWardrobe([item.id]);
        },
        async joinWardrobeAll() {
            
            let hasEmptyWhiteImage = false;
            
            const ids = this.jobDetail.jobs.filter((job) => {
                
                if (!job.white_image) {
                    
                    if (job.run_in_background) return false;
                    
                    hasEmptyWhiteImage = true;
                }
                
                return true;
                
            }).map(job => job.id);
            
            if (!ids.length) return this.$message.info("没有需要导入的图片");
            
            if (hasEmptyWhiteImage) {
                
                const result = await this.$uniConfirm({
                    title: "温馨提示",
                    content: "有图片还未生成AI白底图，是否继续上传衣橱？",
                })
                
                if (!result[1].confirm) return;
            }
            
            await this.doJoinWardrobe(ids);
        },
        async doJoinWardrobe(ids) {
            const data = {
                image_ids: ids,
                job_id: this.id,
            }
            
            this.$loading.show('加入中...');
            
            try {
                const result = await api.post('/ast-wardrobe-job/join-wardrobe', data);
                
                this.$loading.hide();
                
                if (result.code === 0) {
                    this.$message.success("加入成功！");
                    this.jobDetail.jobs = this.jobDetail.jobs.filter(job => !ids.includes(job.id));
                    return;
                }
                
                if (result.code === 259) {
                    this.showAuth = true;
                } else {
                    this.$message.error(result.msg || "加入失败");
                }
            } catch (error) {
                this.$loading.hide();
            }
        },
        handleUpdate(item, updateAttributes) {
            const index = this.jobDetail.jobs.findIndex(job => job.id === item.id);
            
            if (index !== -1) {
                const updatedItem = {
                    ...this.jobDetail.jobs[index],
                    ...updateAttributes
                };
                
                this.$set(this.jobDetail.jobs, index, updatedItem);
            }
            
            this.tryToRefreshListBackground();
        },
        async checkGenerateAllCost() {
            
            this.$loading.show('请稍后..');
            
            try {
                const result = await api.post('/ast-wardrobe-job/generate-all-cost', {
                    id: this.id
                });
                
                this.$loading.hide();
                
                if (result.code !== 0) return false;
                
                if (result.data.count === 0) {
                    this.$message.info("没有需要生成白底图的照片");
                    return false;
                }
                
                const confirm = await this.$uniConfirm({
                    title: '温馨提示',
                    content: `将您上传的${result.data.count}张图片生产AI白底图预计消耗${result.data.cost}token`,
                });
                
                return confirm[1].confirm;
                
            } catch (error) {
                // 用户点击取消或接口报错
                if (this.$loading) this.$loading.hide();
                return false;
            }
        },
        async handleGenerateAll() {
            
            const confirm = await this.checkGenerateAllCost();
            
            if (!confirm) return;
            
            this.$loading.show('请稍后..');
            
            try {
                const result = await api.post('/ast-wardrobe-job/generate-all', {
                    id: this.id
                });
                
                this.$loading.hide();
                
                if (result.code !== 0) {
                    this.$message.error(result.msg || '操作失败');
                    return;
                }
                
                this.$message.success('操作成功');
                
                this.jobDetail.jobs.forEach(item => {
                    this.$set(item, 'run_in_background', 1);
                });
                
                await this.getJobDetail(true);
                
            } catch (error) {
                
                this.$loading.hide();
                
            }
        },
        tryToRefreshListBackground() {
            const jobs = this.jobDetail.jobs.filter(job => job.run_in_background === 1 && job.white_image === '');
            
            if (jobs.length) {
                console.log('tryToRefreshListBackground');
                // 改用参考代码的 this.$sleep
                this.$sleep(60000).then(() => {
                    if (this.isPageDestroyed) return;
                    this.getJobDetail(true);
                });
            }
        },
        async getJobDetail(isPolling = false) {
            
            if (!isPolling) {
                this.$loading.show();
            }
            
            try {
                const res = await api.get('/ast-wardrobe-job/detail', {id: this.id});
                
                if (!isPolling) this.$loading.hide();
                
                if (res.code !== 0) {
                    if (isPolling) return;
                    
                    this.$message.error(res.msg);
                    await this.$sleep(1000);
                    this.$router.back();
                    return;
                }
                
                if (isPolling && this.jobDetail.jobs) {
                    this.jobDetail.jobs = res.data.jobs;
                } else {
                    this.jobDetail = res.data;
                    
                    if(!this.jobDetail.jobs || this.jobDetail.jobs.length === 0) {
                        this.showUploader = true
                    }
                }
                
                this.tryToRefreshListBackground();
                
                if (!this.jobDetail.wardrobe_authed && !isPolling) {
                    this.showAuth = true;
                }
                
            } catch (error) {
                if (!isPolling) this.$loading.hide();
            }
        }
    }
}
</script>
<style scoped lang="scss">
.job-list {
    width: 650px;
    margin-top: 40px;
    margin-bottom: 60px;
    position: relative;
}

.close-btn {
    position: absolute;
    top: -6px;       /* 根据你的UI需求微调位置 */
    right: -6px;     /* 根据你的UI需求微调位置 */
    width: 24px;
    height: 24px;
    line-height: 22px;
    text-align: center;
    background-color: #d8d8d8; /* 默认灰色背景 */
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    border-radius: 50%; /* 圆形按钮 */
    cursor: pointer;
    z-index: 10;
    transition: background-color 0.2s;
    
    /* 鼠标悬浮时的效果 */
    &:hover {
        background-color: #ff4d4f; /* 悬浮变红，常见的关闭交互 */
    }
}
</style>
